import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IKBCatalogCategoryLearned } from '../interfaces/IBase-knowledge-catalog';
import { BaseKnowledgeCatalogService } from '../services/base-knowledge-catalog.service';
import { I18nService } from 'i18n/i18n.service';

@Component({
  selector: 'biz-base-knowledge-catalog-bizagi-data',
  templateUrl: './base-knowledge-catalog-bizagi-data.component.html',
  styleUrls: ['./base-knowledge-catalog-bizagi-data.component.scss']
})
export class BaseKnowledgeCatalogBizagiDataComponent {
  @Input() filteredCategoryListBizagiData: IKBCatalogCategoryLearned[] = [];
  @Output() refreshBizagiDataOutput = new EventEmitter<Guid>();


  constructor(private _baseKnowledgeCatalogService: BaseKnowledgeCatalogService,
              private _i18nService: I18nService) { }

  selectedItem: any = null;
  kBLearnedWithDetails: any = null;
  isLoadingDetails: boolean = false;

  // Método público para reiniciar la selección
  public resetSelection(): void {
    this.selectedItem = null;
    this.kBLearnedWithDetails = null;
  }
  
  // Child component events
  onItemSelected(item: any) {
    if (!item) { return; }
    this.selectedItem = item;
    this.loadDetails(item.Id);
  }

  refreshBizagiData(item: any) {
    if (!item) { return; }
    this.refreshBizagiDataOutput.emit(item.Id);
    // Optionally reload details if the refreshed item is the selected one
    if (this.selectedItem && this.selectedItem.Id === item.Id) {
      this.loadDetails(item.Id);
    }
  }

  private loadDetails(id: any) {
    this.isLoadingDetails = true;
    this._baseKnowledgeCatalogService.getDetailsKBLearned(id).subscribe((res) => {
      this.kBLearnedWithDetails = res;
      this.isLoadingDetails = false;
    });
  }

  getFrecuencyTranslated(frecuency: any): string {
   return this._i18nService.instant('BASEKNOWLEDGECATALOG.' + frecuency.toLocaleUpperCase());
  }
}
